import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { colors } from "../theme/tokens";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Flex direction="column" minH="100vh" bg={colors.pageBackground} color={colors.bodyText}>
      <Header />
      <Box as="main" flex="1" width="100%">
        {children}
      </Box>
      <Footer />
    </Flex>
  );
};

export default Layout;
